import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminPlatformMonitor = lazy(() => import("@/pages/admin/AdminPlatformMonitor"));

export const Route = createFileRoute("/admin/platform-monitor")({
  component: AdminPlatformMonitor,
});
